
import Vue from 'vue'

export default Vue.extend({
  name: 'Portion',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
